"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _utils = require("./utils");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var utils = _interopRequireWildcard(require("../../shared"));

var _customPropTypes = require("../../shared/utils/customPropTypes");

require("./Pagination.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Pagination(_ref) {
  var _onClick = _ref.onClick,
      index = _ref.index,
      menuSize = _ref.menuSize,
      passAttributeToMenuItem = _ref.passAttributeToMenuItem,
      showEndOfMenu = _ref.showEndOfMenu,
      showPrevAndNext = _ref.showPrevAndNext,
      totalPages = _ref.totalPages,
      className = _ref.className,
      Component = _ref.componentEl,
      margin = _ref.margin,
      padding = _ref.padding,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["onClick", "index", "menuSize", "passAttributeToMenuItem", "showEndOfMenu", "showPrevAndNext", "totalPages", "className", "componentEl", "margin", "padding"]);

  var cssClasses = ['st_pagination'];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  cssClasses = utils.spacing.addSpacingClasses({
    margin: margin,
    padding: padding,
    cssClasses: cssClasses
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: cssClasses.join(' ')
  }, showPrevAndNext && totalPages > menuSize && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    className: "st_pagination__first-button",
    componentEl: Component,
    disabled: index === 1,
    onClick: function onClick(e) {
      return _onClick(e, 1);
    },
    tertiary: true,
    type: "button"
  }, otherProps, passAttributeToMenuItem(1)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "caret-left",
    className: "st_pagination__icon-first"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "caret-left",
    className: "st_pagination__icon-second"
  })), showPrevAndNext && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    className: "st_pagination__prev-button",
    componentEl: Component,
    disabled: index === 1,
    iconPosition: "left",
    onClick: function onClick(e) {
      return _onClick(e, index - 1);
    },
    tertiary: true,
    type: "button"
  }, otherProps, passAttributeToMenuItem(index - 1)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "mlg",
    type: "caret-left"
  })), (0, _utils.mapButtons)(Component, index, menuSize, _onClick, otherProps, passAttributeToMenuItem, totalPages), showEndOfMenu && index + Math.ceil((menuSize + 1) / 2) <= totalPages && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "st_pagination__ellipsis"
  }, "..."), /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    componentEl: Component,
    disabled: index === totalPages,
    margin: {
      left: 'xs',
      right: 'xs'
    },
    onClick: function onClick(e) {
      return _onClick(e, totalPages);
    },
    tertiary: true,
    type: "button"
  }, otherProps, passAttributeToMenuItem(totalPages)), totalPages)), showPrevAndNext && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    className: "st_pagination__next-button",
    componentEl: Component,
    disabled: index === totalPages,
    iconPosition: "right",
    onClick: function onClick(e) {
      return _onClick(e, index + 1);
    },
    tertiary: true,
    type: "button"
  }, otherProps, passAttributeToMenuItem(index + 1)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    size: "mlg",
    type: "caret-right"
  })), showPrevAndNext && totalPages > menuSize && /*#__PURE__*/_react["default"].createElement(_Button["default"], _extends({
    className: "st_pagination__last-button",
    componentEl: Component,
    disabled: index === totalPages,
    onClick: function onClick(e) {
      return _onClick(e, totalPages);
    },
    tertiary: true,
    type: "button"
  }, otherProps, passAttributeToMenuItem(totalPages)), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "caret-right",
    className: "st_pagination__icon-first"
  }), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    type: "caret-right",
    className: "st_pagination__icon-second"
  })));
}

Pagination.propTypes = {
  /** a function to handle click events in the menu, takes in the click event and index */
  onClick: _propTypes["default"].func,

  /** current index, required */
  index: _customPropTypes.positiveNonZeroIntPropType.isRequired,

  /** number of items to be displayed in the menu, defaults to 5 */
  menuSize: _propTypes["default"].number,

  /**
   * a function passed to each item in the menu, takes in the index value of that item, and
   * returns an object comprised of any key value pairs that need to be passed as props to each
   * item in the menu (e.g. i => ({ to: `/?page=${i}` }), if a react-router `Link` tag is used for
   * each item), optional
   */
  passAttributeToMenuItem: _propTypes["default"].func,

  /**
   * a flag that indicates whether or not to show the last item in the menu if applicable, defaults
   * to false
   */
  showEndOfMenu: _propTypes["default"].bool,

  /**
   * a flag that indicates whether or not to show the "Prev" and "Next" buttons and "First" and
   * "Last" buttons if `totalPages` is larger than `menuSize`, defaults to true
   */
  showPrevAndNext: _propTypes["default"].bool,

  /** the total number of pages available, required */
  totalPages: _customPropTypes.positiveNonZeroIntPropType.isRequired,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** dom element or component to use for the button */
  componentEl: utils.componentEl.props,

  /** margin for component, if any */
  margin: utils.spacing.marginProps,

  /** padding for component, if any */
  padding: utils.spacing.paddingProps
};
Pagination.defaultProps = {
  onClick: function onClick() {},
  menuSize: 5,
  passAttributeToMenuItem: function passAttributeToMenuItem() {},
  showEndOfMenu: false,
  showPrevAndNext: true,
  className: null,
  componentEl: _Button["default"],
  margin: null,
  padding: null
};
var _default = Pagination;
exports["default"] = _default;